import { mapGetters } from "vuex";
import expenseAccount from "@/services/expenseAccount.js";
import Utils from "@/mixins/Utils";
import orderBy from 'lodash/orderBy'
const Datepicker = () => import("vuejs-datepicker/dist/vuejs-datepicker");

export default {
  components: {
    Datepicker,
  },
  data: () => ({
    agency: {},
    options: [],
    dateStartPicker: '',
    dateEndPicker: '',
    selected: null,
    expenseList: [],
    currentPage: 1,
    perPage: 10,
    isLoading: true,
    listFields: []
  }),
  mixins: [Utils],
  async created() {
    this.listFields = [
      {
        key: 'dateNoteDeFrais',
        label: this.$t('expense-account-view-date-row'),
      },
      {
        key: 'typeFrais',
        label: this.$t('expense-account-view-type-row'),
      },
      {
        key: 'provider',
        label: this.$t('expense-account-view-provider-row'),
      }, {
        key: 'amountTTC',
        label: this.$t('expense-account-view-amountTTC-row'),
      }, {
        key: 'pkStatus',
        label: this.$t('expense-account-view-status-row'),
      }
    ]
    await this.listTypesExpense();
    await this.fetchListExpense()
  },
  computed: {
    ...mapGetters({
      expenseTypes: "expenseTypes"
    }),
    expenses() {
      return this.expenseList.slice(
        (this.currentPage - 1) * this.perPage,
        this.currentPage * this.perPage
      );
    }
  },
  methods: {
    renderType(typeId) {
      return this.expenseTypes.find((item) => item.value === Number(typeId)).text
    },
    onRowClicked(row) {
      this.$store.commit('EXPENSE_SELECTED', row)
      this.$router.push({
        name: 'employee-form',
        params: { type: 'edit' },
        query: { id: row.pkNoteDeFrais },
      })
    },
    async listTypesExpense() {
      try {
        const { data } = await expenseAccount.getListTypeExpense()
        this.options = data.map((type) => ({ value: type.Pk, text: type.Name }))
        this.$store.commit('SET_EXPENSE_TYPES', this.options)
      } catch (error) {
      }
    },
    async fetchListExpense() {
      try {
        const { data } = await expenseAccount.getListExpense()
        this.expenseList = orderBy(data, 'dateNoteDeFrais', ['desc', 'asc'])
      } catch (error) {
      } finally {
        this.isLoading = false
      }
    }
  },
};
